<div class="loader">
  <div class="content-loader">
    <span> {{"GENERIC_LOADING" | translate:locale.language }}</span>
    <div class="fa-1x">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  </div>
</div>
